import {
    Button,
    Form,
    Row,
    Col,
    Select,
    Table,
    Tooltip,
    Tag,
    Input,
    DatePicker,
    Space,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import IconNotFound from '../../../assets/Images/icons/empty';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import DataBreachService from '../../../services/DataBreach.service';
import { ROUTER } from '../../../constants/router';
import parse from 'html-react-parser';
import moment from 'moment';
import ModalManual from './components/ModalManual';
import usePermission from '../../../hooks/usePermission';
import classNames from 'classnames';

const { RangePicker } = DatePicker;
const { Option } = Select;

const DataBreachLogList = () => {
    const { t, i18n } = useTranslation('data-breach');

    const { isAuditor, isUser } = usePermission();

    const [form] = Form.useForm();
    const [manualForm] = Form.useForm();
    const [downloading, setDownloading] = useState(false);

    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState({
        p: 1,
        ps: 10,
        s: 'reportDate',
        sd: 'desc',
    });
    const [searchValue, setSearchValue] = useState({
        eventName: null,
        status: null,
        startDate: null,
        endDate: null,
        targetStartDate: null,
        targetEndDate: null,
    });
    const [loading, setLoading] = useState(0);

    const [data, setData] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);

    useEffect(() => {
        if (loading === 0) {
            // getResponsibilityList(currentPage);
            searchDataBreachLog(searchValue, currentPage);
            setLoading(1);
        }
    }, [currentPage, loading, searchValue]);

    const searchDataBreachLog = (searchValue, pageValue) => {
        // setData();
        const payload = {
            eventName: searchValue.eventName || null,
            status: searchValue.status || null,
            startDate: searchValue.startDate || null,
            endDate: searchValue.endDate || null,
            targetStartDate: searchValue.targetStartDate || null,
            targetEndDate: searchValue.targetEndDate || null,
            p: pageValue.page || 1,
            ps: pageValue.pageSize || 10,
            s: pageValue.sortBy || 'reportDate',
            sd: pageValue.sortDirection || 'desc',
        };
        DataBreachService.getDataBreachLogList(payload).then((res) => {
            setData(res?.data?.resultData?.result || []);
            setCurrentPage({
                page: res?.data?.resultData.page,
                pageSize: res?.data?.resultData.pageSize,
                total: res?.data?.resultData.total,
            });
        });
    };

    useEffect(() => {
        const getStatusList = async () => {
            try {
                const { data } =
                    await DataBreachService.getStatusDataBreachList();
                if (data?.resultData) {
                    setStatusOptions(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getStatusList();
    }, []);

    const columns = [
        {
            title: t('Incident'),
            dataIndex: 'dataBreachEventName',
            key: 'dataBreachEventName',
            sorter: () => null,
            render: (value, record) => {
                return (
                    <div className="space-y-1">
                        <div className="text-sm">{value}</div>
                    </div>
                );
            },
        },
        {
            title: t('Investigator'),
            dataIndex: 'investigator',
            key: 'investigator',
            render: (text, record) => {
                return (
                    <div className="text-sm">
                        {record.investigator ? (
                            <p
                                dangerouslySetInnerHTML={{
                                    __html: record.investigator.replace(
                                        /, /g,
                                        '<br />'
                                    ),
                                }}
                            ></p>
                        ) : (
                            ''
                        )}
                    </div>
                );
            },
        },
        {
            title: t('Incident Status'),
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            render: (status, record) => (
                <>
                    {record.statusEn === 'New' && (
                        <Tag className="rounded-xl -my-1 text-center bg-[#1890FF] border-[#1890FF] text-white">
                            {t('New')}
                        </Tag>
                    )}
                    {record.statusEn === 'Under Management' && (
                        <Tag className="rounded-xl -my-1 text-center bg-[#F9C153] border-[#F9C153] text-white">
                            {t('Under Management')}
                        </Tag>
                    )}
                    {record.statusEn === 'Reject' && (
                        <Tag className="rounded-xl -my-1 text-center bg-[#F0536F] border-[#F0536F] text-white">
                            {t('Reject')}
                        </Tag>
                    )}
                    {record.statusEn === 'Resolved' && (
                        <Tag className="rounded-xl -my-1 text-center bg-[#4ACE8F] border-[#4ACE8F] text-white">
                            {t('Resolved')}
                        </Tag>
                    )}
                </>
            ),
        },
        {
            title: t('Outcome'),
            dataIndex: 'outCome',
            key: 'outCome',
            sorter: true,
            render: (text, record) => {
                return (
                    <div className="text-sm">
                        <p>
                            {record.outCome === '1'
                                ? t('High risk to data subject')
                                : record.outCome === '2'
                                ? t('No high risk to data subject')
                                : record.outCome === '3'
                                ? t('Not sure')
                                : '-'}
                        </p>
                    </div>
                );
            },
        },
        {
            title: t('Reported'),
            dataIndex: 'isReport',
            key: 'isReport',
            sorter: true,
            align: 'center',
            render: (text, record) => {
                return (
                    <div className="text-sm">
                        <p>{record.isReport ? t('Yes') : t('No')}</p>
                    </div>
                );
            },
        },
        {
            title: t('Notification Date'),
            dataIndex: 'reportDate',
            key: 'reportDate',
            sorter: true,
            render: (text, record) => {
                return (
                    <div className="text-sm">
                        <p>{record.reportDate}</p>
                    </div>
                );
            },
        },
        {
            title: t('Remaining Time Label'),
            dataIndex: 'remainingHours',
            key: 'remainingHours',
            sorter: true,
            align: 'center',
            render: (text, record) => {
                return (
                    <div className="text-black font-semibold text-sm">
                        <p>
                            {record.remainingHours !== '-'
                                ? t('Remaining Time', {
                                      hr: record.remainingHours,
                                  })
                                : '-'}
                        </p>
                    </div>
                );
            },
        },
        {
            title: t('Target Date'),
            dataIndex: 'targetDate',
            key: 'targetDate',
            sorter: true,
            render: (text, record) => {
                return (
                    <div className="text-sm">
                        <p>{record.targetDate}</p>
                    </div>
                );
            },
        },
        {
            title: t('Action'),
            key: 'action',
            width: 200,
            align: 'center',
            render: (text, record) => (
                <span className="space-x-2">
                    <Tooltip
                        placement="bottom"
                        title={t('Edit')}
                        className="cursor-pointer hover:opacity-80"
                    >
                        <button
                            disabled={isAuditor || isUser}
                            onClick={() =>
                                navigate(
                                    `${ROUTER.DATA_BREACH.LOG_FORM}/${record.tdataBreachId}`
                                )
                            }
                            className="disabled:cursor-not-allowed"
                        >
                            <svg
                                className={classNames({
                                    'opacity-50': isAuditor || isUser,
                                })}
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    width="32"
                                    height="32"
                                    rx="6"
                                    fill="#F3F6F9"
                                />
                                <path
                                    d="M20.6586 9.34131L22.6586 11.3413L21.1339 12.8666L19.1339 10.8666L20.6586 9.34131ZM13.3333 18.6666H15.3333L20.1913 13.8086L18.1913 11.8086L13.3333 16.6666V18.6666Z"
                                    fill="#7B67FB"
                                />
                                <path
                                    d="M20.6667 20.6667H13.4387C13.4213 20.6667 13.4033 20.6733 13.386 20.6733C13.364 20.6733 13.342 20.6673 13.3193 20.6667H11.3333V11.3333H15.898L17.2313 10H11.3333C10.598 10 10 10.5973 10 11.3333V20.6667C10 21.4027 10.598 22 11.3333 22H20.6667C21.0203 22 21.3594 21.8595 21.6095 21.6095C21.8595 21.3594 22 21.0203 22 20.6667V14.888L20.6667 16.2213V20.6667Z"
                                    fill="#7B67FB"
                                />
                            </svg>
                        </button>
                    </Tooltip>
                </span>
            ),
        },
    ].filter((item) => !item.hidden);

    const paginationProps = {
        current: parseInt(currentPage.page),
        total: parseInt(currentPage.total),
        showSizeChanger: true,
        showTotal: (total, range) => ` ${range[0]}-${range[1]} of ${total} `,
    };

    const onPageChange = async (pagination, filters, sorter) => {
        const pageValues = {
            page: pagination.current,
            pageSize: pagination.pageSize,
            sortBy: sorter && sorter.order ? sorter.columnKey : 'reportDate',
            sortDirection:
                sorter && sorter.order
                    ? sorter.order === 'ascend'
                        ? 'asc'
                        : 'desc'
                    : 'desc',
            //   total: pageValue.total,
            total: currentPage.total,
        };
        setCurrentPage(pageValues);
        searchDataBreachLog(searchValue, pageValues);
    };

    const onSearch = async () => {
        const { getFieldsValue } = form;
        const searchValues = {
            eventName: getFieldsValue().eventName || null,
            status: getFieldsValue().status || null,
            startDate: getFieldsValue()?.notifyDateRange
                ? moment(getFieldsValue().notifyDateRange[0]).toISOString()
                : '',
            endDate: getFieldsValue()?.notifyDateRange
                ? moment(getFieldsValue().notifyDateRange[1]).toISOString()
                : '',
            targetStartDate: getFieldsValue()?.targetDateRange
                ? moment(getFieldsValue().targetDateRange[0]).toISOString()
                : '',
            targetEndDate: getFieldsValue()?.targetDateRange
                ? moment(getFieldsValue().targetDateRange[1]).toISOString()
                : '',
        };
        setSearchValue(searchValues);
        const search = {
            p: 1,
            ps: 10,
            s: 'reportDate',
            sd: 'desc',
        };
        searchDataBreachLog(searchValues, search);
    };

    const [open, setOpen] = useState(false);

    const download = async (fileType) => {
        try {
            setDownloading(true);
            const { data } = await DataBreachService.export({
                fileType: fileType,
            });
            if (data) {
                const name = `Data Breach Log-${moment(new Date()).format(
                    'YYYY-MM-DD'
                )}`;
                if (fileType === 'xlsx') {
                    let blob = new Blob([data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,',
                    });

                    let a = document.createElement('a');
                    a.href = URL.createObjectURL(blob);
                    a.download = `${name}.xlsx`;
                    a.click();
                    setDownloading(false);
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <div className="bg-gray-body ">
            <div className="title flex">{t('Data Breach Log')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Breach')} / {t('Data Breach Log')}
                </span>
            </div>
            <div className="w-full m-auto">
                <div
                    className="content bg-white px-5 pt-8 pb-2 mt-6"
                    style={{ borderRadius: '6px' }}
                >
                    <div className="search pb-3">
                        <Row className="mb-1 -mt-2">
                            <label
                                style={{ fontSize: '20px', fontWeight: 500 }}
                            >
                                {t('Search Filter')}
                            </label>
                        </Row>
                        <Form
                            form={form}
                            layout="vertical"
                            className="flex flex-wrap items-center gap-4 my-4"
                        >
                            <Form.Item
                                className=""
                                name="eventName"
                                label={t('Search')}
                            >
                                <Input
                                    size="large"
                                    className="rounded-md w-full"
                                    placeholder={t('Incident Investigator')}
                                    allowClear
                                    prefix={<SearchOutlined />}
                                />
                            </Form.Item>
                            <Form.Item
                                className="w-[20%]"
                                name="status"
                                label={t('Status')}
                            >
                                <Select
                                    size="large"
                                    className="w-full"
                                    placeholder={t('Status')}
                                    optionFilterProp="children"
                                >
                                    {statusOptions.map((item) => (
                                        <Option
                                            key={item.statusId}
                                            value={item.statusId}
                                        >
                                            {i18n.language === 'en'
                                                ? item.nameEn
                                                : item.nameTh}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                className=""
                                name="notifyDateRange"
                                label={t('Notification Date Range')}
                            >
                                <RangePicker
                                    size="large"
                                    className="w-full"
                                    placeholder={[
                                        t('Start date'),
                                        t('End date'),
                                    ]}
                                    disabledDate={(current) => {
                                        return (
                                            current &&
                                            current > moment().endOf('day')
                                        );
                                    }}
                                />
                            </Form.Item>
                            <Form.Item
                                className=""
                                name="targetDateRange"
                                label={t('Target Date')}
                            >
                                <RangePicker
                                    size="large"
                                    className="w-full"
                                    placeholder={[
                                        t('Start date'),
                                        t('End date'),
                                    ]}
                                />
                            </Form.Item>
                            <div className=" space-x-2 flex">
                                <Button
                                    size="large"
                                    className="min-w-[120px]"
                                    htmlType="submit"
                                    type="primary"
                                    onClick={(value) => onSearch(value)}
                                    icon={<SearchOutlined />}
                                >
                                    {t('Search')}
                                </Button>
                                <Button
                                    size="large"
                                    className="py-0 px-3 hover:opacity-80"
                                    style={{
                                        borderColor: '#7B67FB',
                                    }}
                                    type="primary"
                                    ghost
                                    onClick={() => {
                                        form.resetFields();
                                        const SearchValue = {
                                            eventName: null,
                                            status: null,
                                            startDate: null,
                                            endDate: null,
                                            targetStartDate: null,
                                            targetEndDate: null,
                                        };
                                        setSearchValue({
                                            eventName: null,
                                            status: null,
                                            startDate: null,
                                            endDate: null,
                                            targetStartDate: null,
                                            targetEndDate: null,
                                        });
                                        setCurrentPage({
                                            page: 0,
                                            pageSize: 10,
                                            sortBy: 'reportDate',
                                            sortDirection: 'desc',
                                        });
                                        searchDataBreachLog(
                                            SearchValue,
                                            currentPage
                                        );
                                    }}
                                >
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M15 5.707L14.293 5L12 7.293L9.707 5L9 5.707L11.293 8L9 10.2925L9.7075 11L12 8.707L14.2935 11L15 10.2935L12.707 8L15 5.707Z"
                                            fill="#7B67FB"
                                        />
                                        <path
                                            d="M2 2C1.73478 2 1.48043 2.10536 1.29289 2.29289C1.10536 2.48043 1 2.73478 1 3V4.585C0.999962 4.7164 1.02582 4.84651 1.07609 4.96791C1.12637 5.0893 1.20008 5.1996 1.293 5.2925L5 9V13C5 13.2652 5.10536 13.5196 5.29289 13.7071C5.48043 13.8946 5.73478 14 6 14H8C8.26522 14 8.51957 13.8946 8.70711 13.7071C8.89464 13.5196 9 13.2652 9 13V12H8V13H6V8.585L5.707 8.2925L2 4.5855V3H12V4H13V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2H2Z"
                                            fill="#7B67FB"
                                        />
                                    </svg>
                                </Button>
                            </div>
                        </Form>
                    </div>
                </div>

                {/* </div> */}
            </div>
            <div className="w-full m-auto">
                <div
                    className="content bg-white p-8 mt-6"
                    style={{ borderRadius: '6px' }}
                >
                    <div className="content pb-3">
                        <Row>
                            <Col span={24}>
                                <Row>
                                    <div className="title ">
                                        {t('List of Data Breach Log')}
                                    </div>
                                </Row>
                                <Row>
                                    <div className="flex justify-between items-center w-full gap-8">
                                        <div className="sub-title">
                                            <span className="text-sm text-gray-400">
                                                {parse(
                                                    t(
                                                        'List of Data Breach Log Details'
                                                    )
                                                )}
                                            </span>
                                        </div>
                                        <Space>
                                            <Button
                                                htmlType="submit"
                                                size="large"
                                                className="border-purple-PHX text-purple-PHX px-10"
                                                onClick={() => {
                                                    download('xlsx');
                                                }}
                                                loading={downloading}
                                            >
                                                {t('Download')}
                                            </Button>
                                            <Button
                                                disabled={isAuditor || isUser}
                                                onClick={() => setOpen(true)}
                                                htmlType="submit"
                                                size="large"
                                                type="primary"
                                                className="px-10"
                                            >
                                                {t('Report Incident')}
                                            </Button>
                                        </Space>
                                    </div>
                                </Row>
                                <Row className="my-4">
                                    <div className="sub-title">
                                        <span className="text-sm text-gray-500 font-semibold">
                                            {t('TotalItems', {
                                                length: currentPage.total,
                                            })}
                                        </span>
                                    </div>
                                </Row>
                            </Col>
                        </Row>

                        <Table
                            locale={{ emptyText: <IconNotFound /> }}
                            className="inbox_table"
                            rowKey={(record, i) => i}
                            //loading={loading}
                            columns={columns}
                            dataSource={data}
                            pagination={paginationProps}
                            onChange={onPageChange}
                        />
                    </div>
                </div>
                {/* </div> */}
            </div>
            <ModalManual
                open={open}
                manualForm={manualForm}
                setOpen={setOpen}
            />
        </div>
    );
};

export default DataBreachLogList;
